// In a Spanish browser a number input only takes "," as decimal separator: typing "68." leaves it
// invalid and empty, and the form then reads 0. This makes the "." key (also the keypad one) type ","
// in every number input, only when the browser reads "," as the decimal separator.
const typeText = (text: string) => document.execCommand('insertText', false, text);

// Types "1,5" in a hidden number input: a browser that reads it as 1.5 uses "," for decimals.
const commaIsDecimal = (): boolean => {
  const probe = document.createElement('input');
  probe.type = 'number';
  probe.setAttribute('aria-hidden', 'true');
  probe.tabIndex = -1;
  probe.style.cssText = 'position:fixed;left:-9999px;top:0;opacity:0';
  document.body.appendChild(probe);
  try {
    probe.focus();
    return typeText('1,5') && probe.value === '1.5';
  } catch {
    return false;
  } finally {
    probe.blur();
    probe.remove();
  }
};

export const handleDecimalPoint = (event: KeyboardEvent) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || input.type !== 'number' || input.readOnly || input.disabled) return;
  if (event.key !== '.' || event.ctrlKey || event.altKey || event.metaKey) return;
  if (typeText(',')) event.preventDefault(); // if the browser could not type it, the "." goes through
};

export const installDecimalPointAsComma = () => {
  if (commaIsDecimal()) document.addEventListener('keydown', handleDecimalPoint, true);
};
